import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'

  return {
    formControl: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px',
      '& .MuiOutlinedInput-root.Mui-disabled': {
        opacity: 0.8 // Padronização da opacidade
      },

      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        '& .MuiOutlinedInput-input': {
          // display: 'flex',
          alignItems: 'center',
          padding: '4px 18px 4px 8px !important',
          backgroundColor:
            theme.palette.type === 'dark'
              ? theme.palette.dark_400.main
              : theme.palette.gray_50.main,
          color:
            theme.palette.type === 'dark'
              ? theme.palette.dark_50.main
              : theme.palette.gray_400.main,
          borderRadius: '8px',
          gap: '8px'
        }
      },
      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
        {
          borderColor: isDark
            ? theme.palette.dark_stroke.main
            : theme.palette.gray_stroke.main
        },
      '&.small .MuiOutlinedInput-root .MuiOutlinedInput-input': {
        padding: '6px 10px!important',
        fontSize: '0.875rem'
      }
    },
    menuList: {
      overflow: 'auto',
      ...theme.scrollbarStyles,
      maxHeight: '300px !important',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    label: {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      fontSize: '0.875rem'
    },
    iconChevronDown: {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      right: '4px !important',
      position: 'absolute !important',
      pointerEvents: 'none'
    },

    selectText: {
      paddingRight: '40px !important',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      display: 'block',
    }
  }
})
